<template>
    <button type="button" class="button-circle" @click="$emit('click')"><slot></slot></button>
</template>

<script>
    export default {
        name: "ButtonCircle",

        emits: [
            'click'
        ]
    }
</script>

<style>
    .button-circle {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 33px;
        border: 1px solid #ddd;
        border-radius: 50%;
        font-size: 18px;
        line-height: 1;
        color: #555;
        background: #fff;
        cursor: pointer;
    }

    .button-circle:hover {
        background: rgba(238, 238, 238, 0.5);
    }

    .button-circle[disabled] {
        color: #555 !important;
        background: #fff !important;
        opacity: 0.5;
        cursor: default;
    }

    .button-circle.active {
        /*background: #c7dcf3;*/
        background: #dddddd;
    }

    .button-circle.active:hover {
        /*background: #d7e6f6;*/
        background: #cfcfcf;
    }

    .button-circle [disabled] {
        color: #eee;
        background: #ddd;
    }

    .icon-revers {
        transform: scaleX(-1);
    }

    .icon-disabled {
        opacity: 0.5;
    }
</style>